module.exports = __webpack_public_path__ + "static/media/eu_perfil_quadrado.db0c0a43.jpg";